module.exports = __webpack_public_path__ + "img/content_2_QualityOriginalFactory.e9d69d95.png";